import axios from "axios";
import apiUrls from "../../api";

interface IPostErrorReport {
  environment: "React";
  trace: Record<string, unknown>;
  context_infos: Record<string, unknown>;
}

export const postErrorReport = ({
  environment = "React",
  trace,
  context_infos,
}: IPostErrorReport) => {
  axios
    .post(apiUrls.userErrorTraces, {
      environment,
      trace,
      context_infos,
    })
    .catch((error) => {
      console.error(error);
    });
};
